import { createContext, useContext } from 'react';

import { User } from '@/features/auth/types';

// Cookie (BFF) session: the server owns authentication, the app only knows who
// is signed in and how to end the session. Logout is a navigation - the
// HttpOnly cookie cannot be touched from JS.
export interface AuthContextValue {
  user: User;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
};

export default useAuth;
